import { PageLoadError } from '@components/page-load-error';
import { getAccountsQueryOptions } from '@features/accounts/api/accounts/get-accounts';
import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import CheckingLayout from 'src/routes/_authenticated/dashboard/-layouts/checking-layout';

export const Route = createFileRoute('/_authenticated/dashboard/checking')({
  component: CheckingLayout,
  errorComponent: ({ error }) => (
    <PageLoadError pageName='Checking' error={error} />
  ),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(getAccountsQueryOptions);
    return null;
  },
  onEnter: () => window.scrollTo(0, 0),
});
